const ACTIONS = {
  FETCH_SITE_ID_INIT: "FETCH_SITE_ID_INIT",
  FETCH_SITE_ID_SUCCESS: "FETCH_SITE_ID_SUCCESS",
  FETCH_SITE_ID_FAILURE: "FETCH_SITE_ID_FAILURE",
};

export default ACTIONS;
